import { FC } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Loader from '../../../../../components/loader/index';
import { Modal } from '../../../../../components/modal/index';
import { useDeleteTemplate } from '../../hooks/use-delete-template.hook';
import { TemplatePopupStore } from '../../store/template-popup.store';

export const DeleteTemplatePopup: FC = () => {
  const isOpen = TemplatePopupStore(({ open }) => open);
  const metadata = TemplatePopupStore(({ metadata }) => metadata);
  const handleAccept = TemplatePopupStore(({ handleAccept }) => handleAccept);
  const handleDismiss = TemplatePopupStore(({ handleDismiss }) => handleDismiss);

  const { deleteTemplate, isPending } = useDeleteTemplate({
    onSuccess: handleAccept,
  });

  const handleConfirmDelete = () => {
    if (metadata) deleteTemplate(metadata);
  };

  return (
    <Modal
      description={<AppFormattedMessage id="DELETE_TEMPLATE_MESSAGE" />}
      dismissButtonContent={<AppFormattedMessage id="NO_KEEP" />}
      isOpen={isOpen}
      onDismiss={handleDismiss}
      onSuccess={handleConfirmDelete}
      successButtonContent={
        isPending ? <Loader iconClassName="size-6" /> : <AppFormattedMessage id="CONFIRM_DELETE" />
      }
      successButtonDisabled={isPending}
      title={<AppFormattedMessage id="DELETE_TEMPLATE_TITLE" />}
    />
  );
};
